__webpack_require__.p = "/quote-generator-react/";